import React, { FC, MouseEventHandler, useState } from 'react';
import { CatalogDetail } from '../../apis/detail-catalog';
import { Container } from '../../components/container/container';
import { Paragraph } from '../../components/typography/paragraph';
import { Step } from '../../components/step/step';
// @ts-ignore
import renderHTML from 'react-render-html';
import striptags from 'striptags';
import { BreadcrumbItem } from '../../components/breadcrumb/breadcrumb';
import { PageBanner } from '../../components/page-banner/page-banner';
import Accordion from '../../components/card-accordion/card-accordion';
import { LocationSection } from './components/location-section';
import {
  ArrowIcon,
  OnlineIcon,
  TrashIcon,
  UserGroupIcon,
  UserIcon,
} from './components/icons';
import styles from './styles.module.css';

export interface CatalogProps extends CatalogDetail {
  onPdfClick?: MouseEventHandler;
  onFavoriteClick?: MouseEventHandler;
  onServiceClick?: MouseEventHandler;
  breadcrumbs: BreadcrumbItem[];
}

export const Catalog: FC<CatalogProps> = ({
  name,
  link,
  isFree,
  isOnline,
  updated_at,
  onPdfClick,
  onFavoriteClick,
  onServiceClick,
  description,
  info,
  steps,
  targets,
  tags,
  department,
  category,
  departmentSections,
  averageRatings,
  id,
  breadcrumbs,
}) => {
  const [selectedCity, setSelectedCity] = useState<string>();
  const [selectedSection, setSelectedSection] = useState<string>();

  const handleCityChange = (value: string) => {
    setSelectedCity(value);
    setSelectedSection(undefined);
  };

  const handleSectionChange = (value: string) => {
    setSelectedSection(value);
  };

  return (
    <div className={styles.catalog}>
      <PageBanner title="Detalhes do Serviço" />

      <Container>
        <div className={styles.mainContent}>
          <div className={styles.contentWrapper}>
            <div className={styles.headerSection}>
              <div className={styles.titleWrapper}>
                <h1 className={styles.title}>{name}</h1>
                <p className={styles.description}>{striptags(description)}</p>
              </div>
            </div>

            <hr className={styles.sectionDivider} />

            <div className={styles.accordionsSection}>
              {steps && steps.length > 0 && (
                <Accordion title="Requisitos" id="requirements">
                  <div className={styles.stepContent}>
                    {steps.map((step) => (
                      <Step
                        key={step.id}
                        number={step.orderIndex}
                        title={step.name}
                      >
                        <Paragraph>{step.description}</Paragraph>
                        {renderHTML(step.htmlContent)}
                        {!!step.documents.length && (
                          <div className={styles.documents}>
                            <h3>Documentos necessários</h3>
                            <ul>
                              {step.documents.map((doc, docIndex) => (
                                <li key={docIndex}>
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.5 13.5L4 10L3 11L7.5 15.5L17.5 5.5L16.5 4.5L7.5 13.5Z"
                                      fill="#999EB0"
                                    />
                                  </svg>
                                  {doc}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </Step>
                    ))}
                  </div>
                </Accordion>
              )}

              {info && info.length > 0 && (
                <Accordion title="Informações Adicionais" id="additional-info" >
                  <div className={styles.stepContent}>
                    {info.map((item) => (
                      <Step key={item.id} icon={item.icon} title={item.title}>
                        {renderHTML(item.text)}
                      </Step>
                    ))}
                  </div>
                </Accordion>
              )}
            </div>

            {departmentSections && departmentSections.length > 0 && (
              <LocationSection
                departmentSections={departmentSections}
                selectedCity={selectedCity}
                selectedSection={selectedSection}
                onCityChange={handleCityChange}
                onSectionChange={handleSectionChange}
              />
            )}
          </div>

          <div className={styles.sideContent}>
            {isOnline && (
              <button className={styles.actionButton} onClick={onServiceClick}>
                <span>Solicitar Serviço</span>
                <ArrowIcon />
              </button>
            )}
            <div className={styles.detailsCard}>
              <div className={styles.detailsTitle}>Detalhes do Serviço</div>
              <div className={styles.detailsList}>
                {category && (
                  <div className={styles.detailsItem}>
                    <div className={styles.detailsIcon}>
                      <UserIcon />
                    </div>
                    <div className={styles.detailsText}>{category.name}</div>
                  </div>
                )}
                {department && (
                  <div className={styles.detailsItem}>
                    <div className={styles.detailsIcon}>
                      <TrashIcon />
                    </div>
                    <div className={styles.detailsText}>
                      {department.shortName || department.name}
                    </div>
                  </div>
                )}
                {targets && targets.length > 0 && (
                  <div className={styles.detailsItem}>
                    <div className={styles.detailsIcon}>
                      <UserGroupIcon />
                    </div>
                    <div className={styles.detailsText}>
                      {targets.join(', ')}
                    </div>
                  </div>
                )}
                {isOnline && (
                  <div className={styles.detailsItem}>
                    <div className={styles.detailsIcon}>
                      <OnlineIcon />
                    </div>
                    <div className={styles.detailsText}>
                      Realização Online Disponível
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};